export const refreshDinsideSesjon = (baseUrl) =>
	refreshSesjon(baseUrl, 'idporten');
export const refreshAnsattSesjon = (baseUrl) =>
	refreshSesjon(baseUrl, 'employee');

const DELAY_MELLOM_KALL = 1000 * 60; // et minutt
let tidSisteKall = 0;

export async function refreshSesjon(baseUrl, realm) {
	if (Date.now() - tidSisteKall < DELAY_MELLOM_KALL) {
		return true;
	}
	tidSisteKall = Date.now();
	const utvidResponse = await fetch(`${baseUrl}/${realm}/extend`, {
		credentials: 'include',
	});
	if (!utvidResponse.ok) {
		throw new Error('Kunne ikke refreshe sesjonen mot OpenAM');
	}
	return true;
}
